import { render, staticRenderFns } from "./r-trigger-trader.vue?vue&type=template&id=65f8a4e0&scoped=true"
import script from "./r-trigger-trader.vue?vue&type=script&lang=js"
export * from "./r-trigger-trader.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-trader.vue?vue&type=style&index=0&id=65f8a4e0&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f8a4e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f8a4e0')) {
      api.createRecord('65f8a4e0', component.options)
    } else {
      api.reload('65f8a4e0', component.options)
    }
    module.hot.accept("./r-trigger-trader.vue?vue&type=template&id=65f8a4e0&scoped=true", function () {
      api.rerender('65f8a4e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-trader.vue"
export default component.exports